/**
 * 从 URL 中获取指定参数的值
 * 支持从 hash 路由和普通路由中获取参数
 * @param {string} name - 参数名
 * @param {string} [url] - 可选，要解析的URL，默认为当前页面URL
 * @returns {string | null} 参数值，如果参数不存在则返回 null
 * 
 * @example
 * // URL: http://example.com/?id=123
 * getQueryString('id') // 返回 '123'
 * 
 * // URL: http://example.com/#/path?id=123
 * getQueryString('id') // 返回 '123'
 * 
 * // URL: http://example.com/#/path?id=123&name=test
 * getQueryString('name') // 返回 'test'
 */
export function getQueryString(name: string, url?: string): string | null {
  // 如果没有传入 URL，使用当前页面的 URL
  const currentUrl = url || window.location.href;
  
  // 尝试从 hash 中获取参数
  const hashIndex = currentUrl.indexOf('#');
  if (hashIndex > -1) {
    const hash = currentUrl.slice(hashIndex + 1);
    // 如果 hash 中包含 ?，说明有查询参数
    const questionMarkIndex = hash.indexOf('?');
    if (questionMarkIndex > -1) {
      const queryString = hash.slice(questionMarkIndex + 1);
      const params = new URLSearchParams(queryString);
      const value = params.get(name);
      if (value) return value;
    }
  }

  // 如果在 hash 中没有找到，尝试从 URL 查询字符串中获取
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
} 